import { useState,useContext,useEffect} from 'react';
import {TEXT} from './text'
import { set_language_arabic, set_language_english } from '../../../App_Settings/Actions';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button,Snackbar, Container, CssBaseline, GridLegacy, TextField, Typography, Checkbox,Link } from '@mui/material';
import { AppGlobalContext } from '../../../App';

function Login_page_body() {
  const language = useSelector((state) => state.App_Settings.language);
  const dispatch = useDispatch();
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [invalidEmailPassword, setInvalidEmailPassword] = useState(false);
  //====================[Generated code by Gemini]======================
  const [rememberMe, setRememberMe] = useState(localStorage.getItem('rememberMe') === 'true'); // Load from localStorage
  const [offlineMode, setOfflineMode] = useState(!navigator.onLine);

  useEffect(() => {
    localStorage.setItem('rememberMe', rememberMe); // Save to localStorage on change
  }, [rememberMe]);

  useEffect(() => {
    if (rememberMe && localStorage.getItem('email')) {
      setEmail(localStorage.getItem('email'));
      // Optionally pre-fill password if security isn't a major concern (NOT RECOMMENDED)
      setPassword(localStorage.getItem('password'));//FIXME: critical part shouldn't go to production or merged to master before consider security issue
    }
  }, [rememberMe]); // Run when rememberMe changes, including initial load
  //====================[Generated code by Copilot]======================
  useEffect(() => {
    const handleOnlineStatus = () => setOfflineMode(!navigator.onLine);
    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);
    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);

  const isPasswordValid = () => {
    const savedPassword = localStorage.getItem('password');
    const savedTimestamp = localStorage.getItem('passwordTimestamp');
    const ttl = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
    if (savedPassword && savedTimestamp) {
      const isWithinTTL = Date.now() - parseInt(savedTimestamp, 10) < ttl;
      return isWithinTTL;
    }
    return false;
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setInvalidEmailPassword(false);
  };
  const AppGlobalContxt = useContext(AppGlobalContext);
  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h4">
          { TEXT.Login[language] }
        </Typography>
        <br />
        <br />
        <br />
        <Box component="form" noValidate sx={{ mt: 3 }}>
          <GridLegacy container spacing={2}>
            <GridLegacy item xs={12}>
              <TextField
                error={invalidEmailPassword}
                required
                fullWidth
                id="email"
                label={ TEXT.EmailAddress[language] }
                name="email"
                value={email}
                onChange={(e) =>{ setEmail(e.target.value);setInvalidEmailPassword(false);}}
                autoComplete="email"
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <TextField
                error={invalidEmailPassword}
                required
                fullWidth
                name="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value);setInvalidEmailPassword(false); }}
                label={ TEXT.Password[language] }
                type="password"
                id="password"
                autoComplete="new-password"
              />
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Button
                // type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={async () => {
                  if (offlineMode) {
                    if (rememberMe && isPasswordValid()) {
                      // Load user metadata from localStorage for offline login
                      const storedMetadata = localStorage.getItem('userMetadata');
                      if (storedMetadata) {
                        try {
                          const userMetadata = JSON.parse(storedMetadata);
                          dispatch({ type: 'SET_USER_METADATA', payload: userMetadata });
                        } catch (error) {
                          console.error('Error parsing user metadata:', error);
                        }
                      }
                      AppGlobalContxt.Body.setPageName("Home");
                    } else {
                      setInvalidEmailPassword(true);
                    }
                    return;
                  }
                  let response;
                  if (window.devMode) {
                    response = await fetch(`http://localhost:80/Log_user_in`,
                      {
                        mode: 'cors',
                        url: `http://localhost:80`,
                        method: 'POST',
                        body: JSON.stringify({
                          email, password
                        })
                      }
                    );
                  } else {
                    response = await fetch(`/Log_user_in`,
                      {
                        method: 'POST',
                        mode: 'cors',
                        body: JSON.stringify({
                          email, password
                        })
                      }
                    );
                  }
                  let response_data;
                  if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                  } else {
                    response_data = await response.json();
                  }
                  if (window.devMode) console.log(response_data);
                  if (response_data.proccess_result === "OK") {
                    // Save user metadata to localStorage
                    if (response_data.userMetadata) {
                      localStorage.setItem('userMetadata', JSON.stringify(response_data.userMetadata));
                      // Dispatch to Redux store
                      dispatch({ type: 'SET_USER_METADATA', payload: response_data.userMetadata });
                    }
                    
                    if (rememberMe) {
                      localStorage.setItem('email', email);
                      localStorage.setItem('password', password);
                      localStorage.setItem('passwordTimestamp', Date.now().toString());
                    } else {
                      localStorage.removeItem('email');
                      localStorage.removeItem('password');
                      localStorage.removeItem('passwordTimestamp');
                    }
                    AppGlobalContxt.Body.setPageName("Home");
                  } else {
                    setInvalidEmailPassword(true);
                  }
                }}
              >
                {TEXT.Login[language]}
              </Button>
            </GridLegacy>
            <GridLegacy item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox 
              //=====================[Generated code by Gemini]======================
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              //=====================================================================
              {...label} /><span>{ TEXT.RememberMe[language] }</span>
            </GridLegacy>
          </GridLegacy>
          
          <GridLegacy container justifyContent="flex-end">
            <GridLegacy item xs={6} sx={{ display: 'flex' }}>
              <Button variant="text" color={'primary'} display={'inline'} sx={{ textDecoration: 'underline',cursor: 'pointer' }} >{ TEXT.ForgetPassword[language] }</Button>
            </GridLegacy>
            <GridLegacy item xs={6} sx={{ display: 'flex' }} justifyContent={"flex-end"}>
              <Button variant="text" color={'primary'} display={'inline'} sx={{ textDecoration: 'underline',cursor: 'pointer' }} onClick={() => AppGlobalContxt.Body.setPageName("SignUp")}>{TEXT.DontHaveAccount[language]}</Button>
            </GridLegacy>
            <GridLegacy item xs={6} sx={{ display: 'flex' }}>
              <Button variant="text" color={'primary'} display={'inline'} sx={{ textDecoration: 'underline',cursor: 'pointer' }} onClick={() => dispatch(set_language_english())}>English</Button>
            </GridLegacy>
            <GridLegacy item xs={6} sx={{ display: 'flex' }} justifyContent={"flex-end"}>
              <Button variant="text" color={'primary'} display={'inline'} sx={{ textDecoration: 'underline',cursor: 'pointer' }} onClick={() => dispatch(set_language_arabic())}>عربي</Button>
            </GridLegacy>
          </GridLegacy>
        </Box>
        <Snackbar
          open={invalidEmailPassword}
          autoHideDuration={5000}
          onClose={handleClose}
          message="Invalid Email or Password"
        />
      </Box>
    </Container>
  );
}

export default Login_page_body;

